
import type { ReceiptApi } from "@/types/api/receipts";
import type { Receipt, PaymentMethod, AllocationStatus, ReconciliationStatus } from "@/types/payments";

function mapPaymentMethodApiToUi(apiMethod: string): PaymentMethod {
  const methodMap: Record<string, PaymentMethod> = {
    "bank_transfer": "bank_transfer",
    "credit_card": "credit_card",
    "direct_debit": "direct_debit",
    "cheque": "cheque",
    "cash": "cash",
  };
  return methodMap[apiMethod.toLowerCase()] ?? "bank_transfer";
}

function mapAllocationStatusApiToUi(apiStatus: string): AllocationStatus {
  const statusMap: Record<string, AllocationStatus> = {
    "unallocated": "unallocated",
    "partially_allocated": "partially_allocated",
    "fully_allocated": "fully_allocated",
    "over_allocated": "over_allocated",
  };
  return statusMap[apiStatus.toLowerCase()] ?? "unallocated";
}

function mapReconciliationStatusApiToUi(apiStatus: string): ReconciliationStatus {
  const statusMap: Record<string, ReconciliationStatus> = {
    "pending": "pending",
    "reconciled": "reconciled",
    "exception": "exception",
  };
  return statusMap[apiStatus.toLowerCase()] ?? "pending";
}

export function mapReceiptApiToUi(apiReceipt: ReceiptApi): Receipt {
  return {
    id: apiReceipt.id,
    receiptNumber: apiReceipt.receiptNumber,
    customerId: apiReceipt.customerId,
    customerName: apiReceipt.customerName,
    customerAccountNumber: apiReceipt.customerAccountNumber,
    receiptDate: new Date(apiReceipt.receiptDate),
    receivedAmount: apiReceipt.receivedAmount,
    allocatedAmount: apiReceipt.allocatedAmount,
    unappliedAmount: apiReceipt.unappliedAmount,
    currency: apiReceipt.currency,
    paymentMethod: mapPaymentMethodApiToUi(apiReceipt.paymentMethod),
    paymentReference: apiReceipt.paymentReference,
    bankReference: apiReceipt.bankReference,
    allocationStatus: mapAllocationStatusApiToUi(apiReceipt.allocationStatus),
    reconciliationStatus: mapReconciliationStatusApiToUi(apiReceipt.reconciliationStatus),
    financeSystemId: apiReceipt.financeSystemId,
    importedAt: apiReceipt.importedAt ? new Date(apiReceipt.importedAt) : new Date(),
    importBatchId: apiReceipt.importBatchId,
    notes: apiReceipt.notes,
    hasPromise: apiReceipt.hasPromise,
    promiseToPayId: apiReceipt.promiseToPayId,
    createdBy: apiReceipt.createdBy,
    createdAt: new Date(apiReceipt.createdAt),
    modifiedBy: apiReceipt.modifiedBy,
    modifiedAt: apiReceipt.modifiedAt ? new Date(apiReceipt.modifiedAt) : undefined,
  };
}
